// ─── ONBOARDING / SIGN-IN PALETTE ─────────────────────────────────────────────
// One fixed, gender-neutral blue-violet palette for the sign-in page and every
// onboarding screen, so they look the same whatever the app theme is (they used
// to follow it: pink on a first install, the chosen background otherwise).
//
// Applied as CSS custom properties ON the screen's own wrapper (see
// onboardingStyles.screenWrap and LoginScreen). Both are portalled to <body>,
// so they would otherwise read the app theme's :root values; setting the same
// variable names on the wrapper overrides them for everything inside, without
// touching the rest of the app. The old pink accents now use the Daydream accent blue.
//
// Buttons are pastel with black text (black on these pastels is well above 4.5:1).
export const OB_BLUE = "#BFD3FA"; // pastel periwinkle (button gradient start)
export const OB_VIOLET = "#DAC8F7"; // pastel lavender (button gradient end)
export const OB_INK = "#000000"; // all onboarding text is black
export const OB_PINK = "#6B78C4"; // Daydream accent (was logo pink): back arrow, current dot. Name kept so call sites stay put.
export const OB_PINK_TEXT = "#000000"; // links/tabs are black now (kept as a name so it can be re-tinted)
export const OB_STRONG = "#8FA6EC"; // mid periwinkle for selected borders / finished dots (pastel is too faint)
// Buttons blend blue -> lavender -> pink, the three colours of the app logo
// (Jade, 2026-10-11). Used by the sign-in page and the Premium purchase page.
export const OB_BTN_PINK = "#F4BCD2";
export const OB_BTN_GRADIENT = `linear-gradient(135deg, ${OB_BLUE}, ${OB_VIOLET} 50%, ${OB_BTN_PINK})`;

export const ONBOARDING_VARS = {
  "--c-pink": OB_PINK,
  "--c-pink-text": OB_PINK_TEXT,
  "--c-primary-light": OB_BLUE,
  "--c-primary-deep": OB_VIOLET,
  "--c-on-primary": "#000000",
  "--c-accent-strong": OB_STRONG,
  "--c-text": OB_INK,
  "--c-text-accent": OB_INK,
  "--c-text-soft": "#333333",
  "--c-bg-card": "#ffffff",
  "--c-bg-active": "#E6E9FF",
  "--c-bg-soft": "#EDEFFF",
  "--c-border-mid": "#D3D8F6",
  // Page background: plain white (Jade, 2026-10-08). Only the background is plain;
  // the buttons, borders and other accents keep the blue-violet palette above.
  "--c-hero-gradient": "#ffffff",
};
